.item {
  display: inline-block;
  background-color: #494c4f;
  color: var(--main-background);
  padding: 1px 2px 2px;
  border: solid 1px var(--calendar-cell-border);
  vertical-align: top;
}

.item a {
  color: var(--main-background);
}

.item a:hover {
  text-decoration: underline;
}
